import { MARGEN_POR_DEFECTO } from './economia';

/**
 * Un producto tiene una sola ficha, se haya importado o no.
 *
 * Por dentro hay dos formas de datos: el candidato que devuelve la búsqueda
 * (camelCase, del proveedor) y la fila del catálogo propio (snake_case, de la
 * base de datos). Esa diferencia es asunto del código y no de quien mira: aquí
 * se reducen las dos a la misma vista para que la ventana sea una.
 */

function imagenesDe(principal, resto) {
    return [principal, ...(Array.isArray(resto) ? resto : [])]
        .filter((url) => typeof url === 'string' && url.length > 0)
        .filter((url, i, todas) => todas.indexOf(url) === i);
}

/** Un producto de los resultados de búsqueda: todavía no es tuyo. */
export function desdeCandidato(p) {
    return {
        origen: 'candidato',
        fuente: p.source,
        externalId: p.externalId,
        almacen: p.warehouse || null,
        titulo: p.title || '',
        imagenes: imagenesDe(p.mainImage, p.images),
        urlProveedor: p.supplierUrl || null,
        descripcionPropia: '',
        costoProducto: Number(p.price) || 0,
        margenPct: MARGEN_POR_DEFECTO,
        // Sin precio fijado: se estima con el margen por defecto.
        precioFijado: null,
        envioGuardado: null,
        catalogo: null,
        crudo: p
    };
}

/** Un producto ya importado: precio, envío y estado son los tuyos. */
export function desdeImportado(p) {
    const envioConocido = p.shipping_cost !== null && p.shipping_cost !== undefined;

    return {
        origen: 'importado',
        fuente: p.source,
        externalId: p.external_id,
        almacen: p.shipping_origin || null,
        titulo: p.custom_title || p.original_title || '',
        imagenes: imagenesDe(p.main_image, p.images),
        urlProveedor: p.supplier_url || null,
        // La importación guardaba como descripción la del listado, que en CJ es
        // una copia del título. Repetir el nombre no es describir nada.
        descripcionPropia:
            p.custom_description && p.custom_description !== p.original_title ? p.custom_description : '',
        costoProducto: Number(p.cost_price) || 0,
        margenPct: Number(p.markup_percentage) || MARGEN_POR_DEFECTO,
        precioFijado: Number(p.custom_price) || 0,
        envioGuardado: envioConocido
            ? {
                costo: Number(p.shipping_cost),
                transportista: p.shipping_carrier || null,
                plazo: p.shipping_days || null,
                origen: p.shipping_origin || null,
                destino: p.shipping_destination || null,
                fecha: p.shipping_quoted_at || null
            }
            : null,
        catalogo: {
            publicado: Boolean(p.external_product_id),
            listingId: p.external_product_id || null,
            estado: p.status || null,
            tienda: p.store?.store_name || null,
            plataforma: p.store?.platform || null,
            creado: p.created_at || null,
            actualizado: p.updated_at || null
        },
        crudo: p
    };
}

export default { desdeCandidato, desdeImportado };
